import { translate } from '../../i18n';
import { formatTime } from '../../utils/timestamp';

interface DataItemConfig {
  name: string;
  getTitle: () => string;
  isValidate: (value) => boolean;
  formatValue: (value) => string;
}

export const DataItemConfigs: DataItemConfig[] = [
  {
    name: 'id',
    getTitle: () => translate('receiptID'),
    isValidate: value => value && value !== '',
    formatValue: value => value,
  },
  {
    name: 'created_at',
    getTitle: () => translate('receiptCreateAt'),
    isValidate: value => value && value > 0,
    formatValue: value => formatTime(value, 'YYYY-MM-DD'),
  },
  {
    name: 'buyer_identifier',
    getTitle: () => translate('buyer-identifier'),
    isValidate: value => value && value !== '',
    formatValue: value => value,
  },
  {
    name: 'buyer_name',
    getTitle: () => translate('buyer-name'),
    isValidate: value => value && value !== '',
    formatValue: value => value,
  },
];
